import { clientSDK } from "@istari-frontend/api-client";
import { queryOptions } from "@tanstack/react-query";

import { DEFAULT_CACHE_TIME } from "~/constants";

export const fileRevisionQueryOptions = (revisionId: string) =>
  queryOptions({
    queryKey: ["revision", revisionId],
    queryFn: () => clientSDK.getRevision(revisionId),
    staleTime: DEFAULT_CACHE_TIME,
  });
